import { selectCheckoutCurrentStep, selectCheckoutSteps } from 'checkout/selectors/checkoutStepsSelectors'
import type { StepClickHandler } from 'LuxKit/Steppers/StepperProgressStep'
import StepperProgressStep from 'LuxKit/Steppers/StepperProgressStep'
import StepperProgressSteps from 'LuxKit/Steppers/StepperProgressSteps'
import StepperProgressText from 'LuxKit/Steppers/StepperProgressText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import useLocalizedCheckoutSteps from './useLocalizedCheckoutSteps'

interface MappedStateProps {
  steps: Array<App.Checkout.CheckoutStep>
  currentStep: App.Checkout.CheckoutStep | undefined
}

interface OwnProps {
  onStepClick?: StepClickHandler
}

type Props = MappedStateProps & OwnProps

function CheckoutStepperProgress(props: Props) {
  const {
    steps: rawSteps,
    currentStep,
    onStepClick,
  } = props

  const steps = useLocalizedCheckoutSteps(rawSteps)

  const currentStepIndex = useMemo<number | undefined>(() => {
    if (!currentStep) return
    const index = steps.findIndex(step => step.key === currentStep.key)
    if (index < 0) return
    return index
  }, [currentStep, steps])

  if (!steps.length || currentStepIndex === undefined) return null

  return <>
    <CSSBreakpoint max="tablet">
      <StepperProgressText
        stepLabel={steps[currentStepIndex].label}
        currentStepNumber={currentStepIndex + 1}
        totalSteps={steps.length}
      />
    </CSSBreakpoint>
    <CSSBreakpoint min="desktop">
      <StepperProgressSteps activeStepIndex={currentStepIndex}>
        {steps.map((step, stepIndex) => <StepperProgressStep
          key={step.key}
          stepIndex={stepIndex}
          label={step.label}
          onStepClick={stepIndex < currentStepIndex ? onStepClick : undefined}
        />)}
      </StepperProgressSteps>
    </CSSBreakpoint>
  </>
}

export default connect<MappedStateProps, {}, OwnProps, App.State>((state) => {
  return {
    steps: selectCheckoutSteps(state),
    currentStep: selectCheckoutCurrentStep(state),
  }
})(CheckoutStepperProgress)
